import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useStore } from "../store/store.context";

const useAuthHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { updateStore } = useStore();
  const hasHandled = useRef(false);

  useEffect(() => {
    // Check if we're on a non-callback page and have auth params
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get("code");
    const state = urlParams.get("state");

    // If we have auth params but we're not on the callback page, redirect to callback
    if (code && location.pathname !== '/auth/callback' && !hasHandled.current) {
      console.log('Auth params detected, redirecting to callback handler...');
      hasHandled.current = true;
      
      // Redirect to the callback page with the same search params
      navigate(`/auth/callback${location.search}`, { replace: true });
    }
  }, [location, navigate]);
};

export default useAuthHandler;
